import storeInfo from '../store'
import { Note } from './types'

export const getNotes = () => (): Note[] => {
  const { notes } = storeInfo.store.getState()
  return notes
}